import React from 'react';
import Plot from 'react-plotly.js';

const Plot2D = ({ data, metadata, title = '2D Plot' }) => {
  console.log('Plot2D received data:', data);
  console.log('Plot2D received metadata:', metadata);
  
  if (!data || !data.x || !data.y) {
    console.error('Plot2D: Invalid data structure:', data);
    return <div className="plot-error">Invalid plot data - missing x or y arrays</div>;
  }

  const plotData = [{
    x: data.x,
    y: data.y,
    type: 'scatter',
    mode: 'lines',
    line: { color: '#2563eb', width: 2 },
    name: data.expression || data.function_name || 'f(x)'
  }];

  const layout = {
    title: {
      text: title,
      font: { size: 16, family: 'Arial, sans-serif' }
    },
    xaxis: {
      title: data.variable || 'x',
      gridcolor: '#e5e7eb',
      zerolinecolor: '#9ca3af'
    },
    yaxis: {
      title: data.function_name || 'f(x)',
      gridcolor: '#e5e7eb',
      zerolinecolor: '#9ca3af'
    },
    plot_bgcolor: '#ffffff',
    paper_bgcolor: '#ffffff',
    margin: { l: 60, r: 30, t: 60, b: 60 },
    showlegend: false
  };

  const config = {
    displayModeBar: true,
    displaylogo: false,
    modeBarButtonsToRemove: ['pan2d', 'lasso2d', 'select2d'],
    responsive: true
  };

  return (
    <div className="plot-container" style={{ width: '100%', height: '400px' }}>
      <Plot
        data={plotData}
        layout={layout}
        config={config}
        style={{ width: '100%', height: '100%' }}
      />
    </div>
  );
};

export default Plot2D;